import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilizationFilter } from 'src/app/post-login/services/stats.model';

@Component({
  selector: 'app-stats-quick-filters',
  templateUrl: './stats-quick-filters.component.html',
  styleUrls: ['./stats-quick-filters.component.scss']
})
export class StatsQuickFiltersComponent implements OnInit {
  @Input() filterData: UtilizationFilter [];
  @Input() hideAllColour: boolean;
  @Input() isAllDisabled: boolean;
  @Input() isInsigniaDisabled: boolean;
  @Output() changeSelectAll = new EventEmitter<UtilizationFilter>();
  constructor() { }

  ngOnInit(): void {
  }

  changeSelect(item: UtilizationFilter) {
    this.changeSelectAll.emit(item);
  }

}
